import API from '../../api';

const types = {
  GET_APPLICATIONS_SUCCESS: 'GET_APPLICATIONS_SUCCESS',
  GET_APPLICATIONS_ERROR: 'GET_APPLICATIONS_ERROR',
  CREATE_APPLICATION_SUCCESS: 'CREATE_APPLICATION_SUCCESS',
  UPDATE_APPLICATION_SUCCESS: 'UPDATE_APPLICATION_SUCCESS',
  DELETE_APPLICATION_SUCCESS: 'DELETE_APPLICATION_SUCCESS',
  SET_FILTER_OPTIONS: 'SET_FILTER_OPTIONS',
}

const state = {
  all: [],
  filterOptions: null,
}

const getters = {
  byId: state => id => {
    return state.all.find(item => item.id == id);
  },

  byPhone: state => phone => {
    return state.all.find(item => item.phone == phone);
  },
}

const actions = {
  get({ commit }, params) {
    return API.applications.get(params).then(response => {
      commit(types.GET_APPLICATIONS_SUCCESS, response.data.result);
      return response;
    }).catch(error => {
      commit(types.GET_APPLICATIONS_ERROR);
    });
  },

  create({ commit }, application) {
    return API.applications.create(application).then(response => {
      const application = response.data.result;
      commit(types.CREATE_APPLICATION_SUCCESS, application);

      return application;
    });
  },

  update({ commit }, application) {
    return API.applications.update(application.id, application).then(response => {
      const application = response.data.result;
      commit(types.UPDATE_APPLICATION_SUCCESS, application);

      return application;
    });
  },

  fetch({ commit }, id) {
    return API.applications.fetch(id).then(response => {
      const application = response.data.result;
      commit(types.UPDATE_APPLICATION_SUCCESS, application);

      return application;
    });
  },

  fetchReSign({ commit }, hash) {
    return API.applications.fetchReSign(hash).then(response => {
      const application = response.data.result;
      commit(types.UPDATE_APPLICATION_SUCCESS, application);

      return application;
    });
  },

  reSign({ commit }, params) {
    return API.applications.reSign(params.hash, params).then(response => {
      const application = response.data.result;
      commit(types.UPDATE_APPLICATION_SUCCESS, application);

      return application;
    });
  },

  delete({ commit }, application) {
    return API.applications.delete(application.id).then(response => {
      commit(types.DELETE_APPLICATION_SUCCESS, application);
    });
  },

  uploadImages({ commit, dispatch }, { id, images }) {
    return API.applications.uploadImages(id, images).then(response => {
      const application = response.data.result;
      commit(types.UPDATE_APPLICATION_SUCCESS, application);

      return application;
    });
  },

  deleteImage({ commit, dispatch }, { id, imageId }) {
    return API.applications.deleteImage(id, imageId).then(response => {
      return dispatch('fetch', id);
    });
  },

  setFilterOptions({ commit }, options) {
    commit(types.SET_FILTER_OPTIONS, options);
  },

  clear({ commit }) {
    commit(types.GET_APPLICATIONS_SUCCESS, []);
  },
}

const mutations = {
  [types.GET_APPLICATIONS_SUCCESS](state, issues) {
    state.all = issues;
  },

  [types.GET_APPLICATIONS_ERROR](state) {
    state.all = [];
  },

  [types.CREATE_APPLICATION_SUCCESS](state, application) {
    state.all.push(application);
  },

  [types.UPDATE_APPLICATION_SUCCESS](state, application) {
    let index = state.all.findIndex(item => item.id == application.id);
    state.all.splice(index, 1, application);
  },

  [types.DELETE_APPLICATION_SUCCESS](state, application) {
    let index = state.all.findIndex(item => item.id == application.id);
    state.all.splice(index, 1);
  },

  [types.SET_FILTER_OPTIONS](state, options) {
    state.filterOptions = options;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
